import React from 'react';
import PropTypes from 'prop-types';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import translate from 'components/hoc/translate';
import compose from 'recompose/compose';
import { fetchMembershipSchedule } from 'store/actions/membership-schedules/fetchMembershipSchedules';
import MembershipScheduleField from './MembershipScheduleField';
import utils from 'helpers/utils';

function MembershipScheduleFieldContainer(props) {
    const {
        data,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound />;
    }

    if (!data) {
        return null;
    }

    return (
        <MembershipScheduleField schedule={ data } title={ utils.firstCharToCamelCase(data.name) } />
    );
}

MembershipScheduleFieldContainer.propTypes = {
    data: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const enhance = compose(
    fetchResourceById({
        resource: 'membership-schedules',
        action: fetchMembershipSchedule,
    }),
    translate,
);

export default enhance(MembershipScheduleFieldContainer);



// WEBPACK FOOTER //
// ./src/components/show/MembershipScheduleFieldContainer.js